import "./Emaar.css";

const Emaar = () => {
  return (
    <iframe
      src="https://view.propvr.tech/f2eon9/projectscene/6662a98d63ea238bc171bfeb/666c1b602bc6bae7a2d7051d"
      className="iframe-fullscreen"
    ></iframe>
  );
};

export default Emaar;
